// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"_2Jqw2"};